import Toll from '../../../../services/toll';

export default {
  props: ['vpSelected'],
  data() {
    return {
      downloadType: undefined,
      errorMessage: undefined
    }
  },
  methods: {
    download(idVp) {
      if(idVp) {
        let req = {
          idIntern: idVp,
          tipo: this.downloadType
        };
        let promise = Toll.exportReceiptVp(req).then(data => {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'ComprovanteVP'.concat(this.downloadType == 'xlsx' ? '.xlsx' : '.pdf'));
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          }).catch(err => {
            this.errorMessage = 'Falha ao emitir o comprovante';
          });
          this.$store.dispatch('loading', promise);
      }
    },
    closeModal() {
      let close = {
        modal: 'print-vp'
      };
      this.$emit('close', close);
      this.downloadType = undefined;
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/modal-print-vp.js